import useLoginCheck from 'hooks/common/useLoginCheck';
import { getControllerList } from 'lib/api/service/dashboard';
import { useQuery } from 'react-query';

const useControllerListModal = () => {
  const { isLoading, error, data, refetch } = useQuery(
    'controllerList',
    () => getControllerList(0),
    {
      cacheTime: 0,
    },
  );
  useLoginCheck(error?.response, refetch);

  return { isLoading, error, data };
};

export default useControllerListModal;
